import { TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { gql } from 'graphql-request';

import { getSharedDictionary } from '@gn-audio/jss-components/getters';
import { SitecoreDictionaryItem } from '@gn-audio/jss-components/types';

import { executeGQLQuery } from './graphqlApi';

import getConfig from '../temp/config';

const PRODUCT_COLOR_HEX_MAPPINGS = '54770CD4-8414-4562-AD68-1A4062DA8F1A';
const colorHexMappingsQuery = gql`
  query ($language: String!, $dataSource: String) {
    item(path: $dataSource, language: $language) {
      children(first: 100) {
        results {
          ... on GroupOption {
            title {
              value
            }
            titleDictionary {
              jsonValue
            }
            value {
              value
            }
          }
        }
      }
    }
  }
`;

interface ColorHexMappingResponse {
  item: {
    children: {
      results: ColorHexMapping[];
    };
  };
}

export interface ColorHexMapping {
  title: TextField;
  titleDictionary: SitecoreDictionaryItem;
  value: TextField;
}

export const fetchColorHexMappings = async (language?: string): Promise<ColorHexMapping[]> => {
  const { defaultLanguage } = getConfig();
  const colorHexMappingResponse = await executeGQLQuery<ColorHexMappingResponse>(
    colorHexMappingsQuery,
    {
      language: language ?? defaultLanguage,
      dataSource: PRODUCT_COLOR_HEX_MAPPINGS,
    }
  );

  if (!colorHexMappingResponse?.item?.children?.results?.length) {
    console.warn('No color hex mappings found.');
    return [];
  }

  const colorHexMappings = colorHexMappingResponse.item.children.results.filter(
    (item) => !!item.value?.value && !!getSharedDictionary(item, 'title')?.value
  );
  return colorHexMappings;
};
